// extracted by mini-css-extract-plugin
module.exports = {"about":"ExpertAbout_about__khQhQ","title":"ExpertAbout_title__9A0J7","description":"ExpertAbout_description__oiL0T"};